import { CUSTOMER_TYPE, PartialPick } from "../../../../../constants";
import { RootState } from "../../../../../models";
import { isHandsetWithLeaseCode, isZeroPlaySubscription } from "../../../../../shared/subscriptionCodeUtils";
import { State as CheckoutState } from "../../../checkout/state/selectors/cartSelectors";
import { getSubscriptions } from "../../../checkout/state/selectors/subscriptionsSelectors";
import { getRetailerState } from "./selectors";

type State = PartialPick<RootState, "retailer" | "checkout">;

const isNewOrPortInSubscriptionType = (phoneNumberType?: string) =>
    phoneNumberType === CUSTOMER_TYPE.NEW ||
    phoneNumberType === CUSTOMER_TYPE.PORT_IN ||
    phoneNumberType === CUSTOMER_TYPE.NEW_OR_PORT_IN;

const isPrepaid = (state: State): boolean => getRetailerState(state)?.customer?.isPrepaid || false;

export const requiresCreditCheck = (state: State): boolean => {
    if (isPrepaid(state)) return false;

    const subscriptions = Object.values(getSubscriptions(state as CheckoutState));
    const hasNewOrPortInSubscription = subscriptions.some(
        (subscription) =>
            isNewOrPortInSubscriptionType(subscription.phoneNumber?.check?.type) &&
            !isZeroPlaySubscription(subscription.code), // not doing cc for new telia trygg subscriptions
    );
    const hasLeaseForHwBundle = subscriptions.some((subscription) => isHandsetWithLeaseCode(subscription.code));

    return hasNewOrPortInSubscription || hasLeaseForHwBundle;
};
